import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const pages = []
const requireComponent = require.context(
  '../views',
  false,
  // 匹配基础组件文件名的正则表达式
  /\.(vue|js)$/
)

// requireComponent.keys().forEach(fileName => {
//   // 获取组件配置
//   const componentConfig = requireComponent(fileName)

//   // 获取组件的 PascalCase 命名
//   const componentName = fileName
//     .split('/')
//     .pop()
//   pages.push({
//     path: componentName.replace('.vue', ''),
//     component: componentConfig.default || componentConfig
//   })
// })
const routes = [{
    path: '/login',
    component: () => import('@/views/login/login'),
    hidden: true
  },
  {
    path: '/updatepwd',
    component: () => import('@/views/login/updatepassword'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/home/layout'),
    name: 'layout',
    children: [{
        path: "/home",
         meta: {
           keepAlive: false, //该字段表示该页面需要缓存
           isBack: false
         },
        name: 'home',
        component: () => import('@/views/home/home'),
      },
      {
        path: "/orgInfo",
        keepAlive: false, //该字段表示该页面需要缓存
        name: 'orgInfo',
        component: () => import('@/views/organizational/info'),
      }, {
        path: "/departmentList",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'departmentList',
        component: () => import('@/views/organizational/department_list'),
      }, {
        path: "/staffList",
        name: 'staffList',
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        component: () => import('@/views/organizational/staff_list'),
      }, {
        path: "/departmentDetail",
        keepAlive: false, //该字段表示该页面需要缓存

        name: 'departmentDetail',
        component: () => import('@/views/organizational/department_detail'),
      }, {
        path: "/staffDetail",
        keepAlive: false, //该字段表示该页面需要缓存
        name: 'staffDetail',
        component: () => import('@/views/organizational/staff_detail'),
      }, {
        path: "/covenantList",

        name: 'covenantList',
        component: () => import('@/views/system/covenantList'),
      }, {
        path: "/flairList",

        name: 'flairList',
        component: () => import('@/views/system/flairList'),
      }, {
        path: "/centerList",
        name: 'centerList',
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        component: () => import('@/views/system/center_list'),
      }, {
        path: "/rate",
        name: 'rate',

        component: () => import('@/views/system/rate'),
      }, {
        path: "/approve",
        name: 'approve',
        component: () => import('@/views/system/approve'),
      }, {
        path: "/logList",
        name: 'logList',
        component: () => import('@/views/system/logList'),
      }, {
        path: "/contractList",
        name: 'contractList',
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },

        component: () => import('@/views/apply/contractList'),
      }, {
        path: "/contractDel",
        name: 'contractDel',
        component: () => import('@/views/apply/contractDel'),
      }, {
        path: "/createtDel",
        name: 'createtDel',
        component: () => import('@/views/apply/createtDel'),
      }, {
        path: "/position",
        name: 'position',
        props: true, // 确保props能够接收到params参数

        component: () => import('@/views/apply/position'),
      }, {
        path: "/licensePosition",
        name: 'licensePosition',
        props: true, // 确保props能够接收到params参数

        component: () => import('@/views/apply/licensePosition'),
      }, {
        path: "/licenseList",
        name: 'licenseList',
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        component: () => import('@/views/apply/licenseList'),
      }, {
        path: "/license",
        name: 'license',
        component: () => import('@/views/apply/license'),
      }, {
        path: "/autoList",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'autoList',
        component: () => import('@/views/examine/autoList'),
      }, 
      {
        path: "/manualList1",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'manualList1',
        component: () => import('@/views/examine/manualList1'),
      }, {
        path: "/manualList3",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'manualList3',
        component: () => import('@/views/examine/manualList3'),
      }, 
      {
        path: "/manualListXs",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'manualListXs',
        component: () => import('@/views/examine/manualListXs'),
      }, {
        path: "/manualListYcl",
        name: 'manualListYcl',
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        component: () => import('@/views/examine/manualListYcl'),
      }, {
        path: "/manualListQtxy",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'manualListQtxy',
        component: () => import('@/views/examine/manualListQtxy'),
      }, {
        path: "/manualList2",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'manualList2',
        component: () => import('@/views/examine/manualList2'),
      }, {
        path: "/commonDel",
        name: 'commonDel',
        component: () => import('@/views/examine/commonDel'),
      }, {
        path: "/approvalList",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'approvalList',
        component: () => import('@/views/examine/approvalList'),
      }, {
        path: "/licenseDel",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'licenseDel',
        component: () => import('@/views/apply/licenseDel'),
      }, {
        path: "/authList",
        meta: {
          keepAlive: true, //该字段表示该页面需要缓存
          isBack: false
        },
        name: 'authList',
        component: () => import('@/views/authority/authList'),
      }, {
        path: "/authDel",
        name: 'authDel',
        component: () => import('@/views/authority/authDel'),
      }, {
        path: "/addMerber",
        name: 'addMerber',
        component: () => import('@/views/authority/addMerber'),
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/404'),
    hidden: true
  },
  {
    path: '/preview',
    component: () => import('@/preview'),
    hidden: true
  },
  // 404 page must be placed at the end !!!
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
const router = new VueRouter({
  mode: 'hash',
  base: '/',
  // scrollBehavior (to, from, savedPosition) {
  //   console.log("---scr   ",savedPosition);
  //     if (savedPosition) {
  //       // 如果 savedPosition 存在，则使用它
  //       return savedPosition
  //     } else {
  //       // 如果不存在，则返回顶部
  //       return { left: 0, top: 0 }
  //     }
  //   },
  routes
})
router.beforeEach((to, form, next) => {
  // console.log(to,"---s--ss",form);
  if(form!=null&& form.name !=null  &&  form.path.includes("home") && (to.path.includes("approvalList") || to.path.includes("autoList")  || to.path.includes("manualList1")  || to.path.includes("manualList2")  || to.path.includes("manualListQtxy")  || to.path.includes("manualListXs")  || to.path.includes("manualListXYcl") ||to.path.includes("contractList")
      ||to.path.includes("staff_list") ||to.path.includes("department_list") ||to.path.includes("licenseDel") ) ){
    to.meta.keepAlive= true
  } else if(form!=null&& form.name !=null  && ( form.path.includes("createtDel") ||form.path.includes("contractDel")) && (to.path.includes("contractList"))){
    to.meta.keepAlive= true
  }else if(form!=null&& form.name !=null  && ( form.path.includes("commonDel")  ) && (to.path.includes("approvalList") || to.path.includes("autoList")  || to.path.includes("manualList1")  || to.path.includes("manualList2")  || to.path.includes("manualListQtxy")  || to.path.includes("manualListXs")  || to.path.includes("manualListYcl")  )){
    // to.meta.keepAlive=to.params&&to.params.back? false: true
    to.meta.keepAlive= true
  } else if(form!=null&& form.name !=null  && ( form.path.includes("department_detail")  ) && (to.path.includes("department_list")    )){
    to.meta.keepAlive= true
  }else if(form!=null&& form.name !=null  && ( form.path.includes("staff_detail")  ) && (to.path.includes("staff_list")    )){
    to.meta.keepAlive= true

  }else if(form!=null&& form.name !=null  && ( form.path.includes("licenseDel")  ) && (to.path.includes("licenseList")    )){
    to.meta.keepAlive=to.params&&to.params.back? false: true

  }else{
    to.meta.keepAlive= false
  }

  next( )
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js